module.exports = new Promise(function(resolve) {
    if (typeof window["crmApp"] !== "undefined") return resolve(window["crmApp"]);
    var resolved = false;
    function done(container) {
      if (resolved) return;
      resolved = true;
      resolve(container);
    }
    var timer = setTimeout(function() {
      console.warn("[MF] Remote crmApp at https://x-crm.his.nhatquang.tech/remoteEntry.js timed out after 3000ms");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    }, 3000);
    var script = document.createElement("script");
    script.src = "https://x-crm.his.nhatquang.tech/remoteEntry.js";
    script.async = true;
    script.onload = function() {
      clearTimeout(timer);
      if (window["crmApp"]) {
        done(window["crmApp"]);
      } else {
        console.warn("[MF] Remote crmApp loaded but container not found");
        done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
      }
    };
    script.onerror = function() {
      clearTimeout(timer);
      console.warn("[MF] Remote crmApp at https://x-crm.his.nhatquang.tech/remoteEntry.js unreachable");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    };
    document.head.appendChild(script);
  });